import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class OrderCancel {
  /* 订单取消列表 */
  static getOrderCancelList(option) {
    let url = `/oa/api/charge/check/page/order/cancel?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 订单取消导入 */
  static postUploadOrderCancel(data) {
    const url = `/oa/api/upload/order/cancel`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default OrderCancel;